import React from 'react';
import $ from 'jquery';
import {observer} from 'mobx-react';
import Button from 'shared/components/buttons/Button';
import ActionLink from 'shared/components/links/ActionLink';

@observer class DropdownSelect extends React.Component {
  state = {status: ''};

  toggleDropdownSelect = (_e) => {
    if (this.state.status === 'is-closed' || !this.state.status) {
      this.setState({ status: 'is-open' });

      setTimeout(() => {
        $(document).one('click', (_e) => {
          this.setState({ status: 'is-closed' });
        });
      }, 0);
    } else {
      this.setState({ status: 'is-closed' });
    }
  };

  render() {
    const {selected, children, disabled, size, buttonTrait, buttonSize, align, className, hideArrow} = this.props;
    const {status} = this.state;

    return (
      <div className={`relative ${className || ''}`}>
        <Button disabled={disabled} trait={buttonTrait} size={buttonSize} className={`${status}`} onClick={this.toggleDropdownSelect}>
          <span>{selected}</span>
          {!hideArrow && <i className='material-icons pl2'>{'arrow_drop_down'}</i>}
        </Button>
        {status && <ul className={`DropdownSelect DropdownSelect--${size} ${status} ${align}-0`}>
          {children}
        </ul>}
      </div>
    );
  }
}

const DropdownSelectOption = ({text, onClick, active, separator, icon}) => {
  const colour = active ? 'white' : 'haze';
  return (
    <li className={`${separator ? 'separator' : ''}`}>
      <ActionLink className={`${colour} ${active ? 'selected' : ''}`} onClick={() => onClick()}>
        {icon && <i className='material-icons h2 align-middle mr2'>{icon}</i>}
        <span className='align-middle'>{text}</span>
      </ActionLink>
    </li>
  );
};

DropdownSelect.Option = DropdownSelectOption;

DropdownSelect.defaultProps = {
  size: 'md',
  align: 'right'
};

export default DropdownSelect;
